{
  "myData.export.section.heading": "Download your data",
  "myData.export.section.description": "You can download the data this service holds about you. Data managed in another service is not included in the download; it appears as a link instead.",
  "myData.export.trigger": "Download my data",
  "myData.export.pending": "Preparing…",
  "myData.export.ready": "Your data is ready to download.",
  "myData.export.download.json": "Download machine-readable file (JSON)",
  "myData.export.download.text": "Download readable file (text)",
  "myData.export.close": "Close",
  "myData.export.error": "Downloading your data failed. Please try again."
}
